const userRouteKey = "user-route-key";

// 客户管理跳转到订单管理和设备管理
export const getUserRouteParams = () => {
  try {
    const data = localStorage.getItem(userRouteKey);
    const parsed = data ? JSON.parse(data) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Failed to get route params:", error);
    return [];
  }
};

export const setUserRouteParams = (data) => {
  try {
    localStorage.setItem(userRouteKey, JSON.stringify(data));
  } catch (error) {
    console.error("Failed to set route params:", error);
  }
};
